"use client";

import styles from "./AuthorizeSubmitButton.module.scss";

import { useAuthorizeForm } from "../../_hooks";
import { Button } from "@vetty/ui";

/**
 * AuthorizeSubmitButton Component
 *
 * Submit button for authorize form using custom hook for logic.
 * Simplified component that delegates all logic to useAuthorizeForm hook.
 */
export const AuthorizeSubmitButton = () => {
  // Get login functionality from custom hook
  const { submitLogin, loading } = useAuthorizeForm();

  return (
    <Button
      disabled={loading}
      loading={loading}
      onClick={submitLogin}
      className={styles["comp"]}
    >
      Authorize
    </Button>
  );
};
